import { render } from "./DesktopMenuButton.vue?vue&type=template&id=071b5126&scoped=true"
import script from "./DesktopMenuButton.vue?vue&type=script&lang=js"
export * from "./DesktopMenuButton.vue?vue&type=script&lang=js"

import "./DesktopMenuButton.vue?vue&type=style&index=0&id=071b5126&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071b5126"]])

export default __exports__